/**
 * EmployersPage.
 *
 * The `/employers` route renders the fully-working employer lookup UI so the
 * nav "Employers" link lands on a functional fuzzy-search + detail experience
 * rather than a stub. The lookup itself lives in {@link EmployerLookupPage}.
 */
import { EmployerLookupPage } from './EmployerLookupPage';

export function EmployersPage() {
  return <EmployerLookupPage />;
}
